import React, { useEffect, useState } from "react";

const TestimonialSection = () => {
  const [testimonial, setTestimonial] = useState([]);
  const [testimonialtext, setTestimonialText] = useState([]);

  useEffect(() => {
    fetch(`https://ai-automation-audit-01-e0855711738d.herokuapp.com/testimonialtext`)
      .then((res) => res.json())
      .then((info) => setTestimonialText(info));
  }, []);

  useEffect(() => {
    fetch(`https://ai-automation-audit-01-e0855711738d.herokuapp.com/testimonials`)
      .then((res) => res.json())
      .then((info) => setTestimonial(info));
  }, []);
  return (
    <>
      <section className="testimonial-section centred pb_140 modern-home-section">
        <div className="shape">
          <div className="shape-1 rotate-me" style={{ backgroundImage: 'url(assets/images/shape/shape-45.png)' }} />
          <div className="shape-2" style={{ backgroundImage: 'url(assets/images/shape/shape-46.png)' }} />
        </div>
        <div className="auto-container">
          {testimonialtext.slice(0, 1).map((item) => (
            <div className="modern-section-heading text-center" key={item._id}>
              <span className="sub-title">{item.testimonialText}</span>
              <h2>{item.testimonialHeading}</h2>
              <p>Real feedback from businesses using AuraWeb to automate lead handling, customer questions, and follow-up.</p>
            </div>
          ))}

          <div className="row g-4">
            {testimonial.map((item) => (
              <div className="col-lg-4 col-md-6 col-sm-12" key={item._id}>
                <div className="testimonial-block-one modern-testimonial-card">
                  <div className="inner-box">
                    <figure className="thumb-box"><img src={item.image} alt={item.personName} /></figure>
                    <h4>{item.personName}</h4>
                    <span className="designation">{item.personTitle}</span>
                    <ul className="rating">
                      <li><i className="icon-19" /></li>
                      <li><i className="icon-19" /></li>
                      <li><i className="icon-19" /></li>
                      <li><i className="icon-19" /></li>
                      <li><i className="icon-19" /></li>
                    </ul>
                    <p>{item.desc}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default TestimonialSection;
